export const LOGO_VS_LOGO_BASE_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/ESPN/logo-vs-logo`;

export const getLeagueLogoUrl = (leagueId: string): string => `${LOGO_VS_LOGO_BASE_URL}/ligas/${leagueId}.png`;

export const getTeamShieldUrl = (leagueId: string, teamId: string): string =>
  `${LOGO_VS_LOGO_BASE_URL}/escudos/${leagueId}/${teamId}.png`;
